var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2862_17996)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(-928 -437)",
    fill: "#221F1F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -478,
    y: -59,
    width: 622,
    height: 62,
    rx: 31,
    fill: "#494141",
    fillOpacity: 0.4,
    stroke: "#424141",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2862_17996)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -928,
    y: -437,
    width: 1920,
    height: 1080,
    fill: "black",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2862_17996)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -205,
    y: -48,
    width: 474,
    height: 303,
    rx: 16,
    fill: "#FBFBFB",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_2862_17996)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2862_17996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.359 21.3903L41.2972 15.3285C40.6467 14.678 39.7644 14.3125 38.8445 14.3125H19.4688C17.553 14.3125 16 15.8655 16 17.7812V43.2188C16 45.1345 17.553 46.6875 19.4688 46.6875H44.9062C46.822 46.6875 48.375 45.1345 48.375 43.2188V23.843C48.375 22.9231 48.0095 22.0408 47.359 21.3903ZM32.1875 42.0625C29.6332 42.0625 27.5625 39.9918 27.5625 37.4375C27.5625 34.8832 29.6332 32.8125 32.1875 32.8125C34.7418 32.8125 36.8125 34.8832 36.8125 37.4375C36.8125 39.9918 34.7418 42.0625 32.1875 42.0625ZM39.125 20.0562V27.3203C39.125 27.7992 38.7367 28.1875 38.2578 28.1875H21.4922C21.0133 28.1875 20.625 27.7992 20.625 27.3203V19.8047C20.625 19.3258 21.0133 18.9375 21.4922 18.9375H38.0063C38.2363 18.9375 38.4569 19.0288 38.6195 19.1915L38.871 19.443C38.9515 19.5235 39.0154 19.6191 39.059 19.7243C39.1026 19.8295 39.125 19.9423 39.125 20.0562Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2862_17996",
    x: -948.319,
    y: -457.319,
    width: 1960.64,
    height: 1120.64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 10.1593
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2862_17996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2862_17996",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2862_17996",
    x: -229,
    y: -64,
    width: 522,
    height: 351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2862_17996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2862_17996",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2862_17996",
    x1: 2.58586,
    y1: 7.61801e-7,
    x2: 43.2411,
    y2: 52.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF2573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC1A7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2862_17996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(-928 -437)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2862_17996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.375,
    height: 37,
    fill: "white",
    transform: "translate(16 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.b2edd3e69be56db9f6927d5dad07775b.svg";
export { ForwardRef as ReactComponent };